const initialState = {
    isAddingTicket: false,
    isGettingTicketList: false,
    ticketList: [],
};

const AddTicketReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_TICKET_REQUEST":
            return { ...state, isAddingTicket: true };

        case "ADD_TICKET_SUCCESS":
        case "ADD_TICKET_FAILURE":
            return { ...state, isAddingTicket: false };



        case "TICKET_LIST_REQUEST":
            return {
                ...state,
                isGettingTicketList: true,
            };
        case "TICKET_LIST_SUCCESS":
            return {
                ...state,
                ticketList: action.payload,
                isGettingTicketList: false,
            };
        case "TICKET_LIST_ERROR":
            return {
                ...state,
                isGettingTicketList: false,
            };

        default:
            return state;
    }
};

export default AddTicketReducer;
